(function () {
  function initPolariveScrollReveal() {
    var elements = document.querySelectorAll('[data-polarive-reveal]');

    if (!elements.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach(function (element) {
        element.classList.add('polarive-reveal-visible');
      });

      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var element = entry.target;
          var delay = element.getAttribute('data-polarive-delay');

          if (delay) {
            element.style.transitionDelay = delay + 'ms';
          }

          element.classList.add('polarive-reveal-visible');
          observer.unobserve(element);
        });
      },
      {
        threshold: 0.16,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    elements.forEach(function (element) {
      if (element.classList.contains('polarive-reveal-visible')) return;

      observer.observe(element);
    });
  }

  document.addEventListener('DOMContentLoaded', initPolariveScrollReveal);

  document.addEventListener('shopify:section:load', function () {
    initPolariveScrollReveal();
  });
})();